<template>
  <v-app v-if="!accessToken" id="yywd-front">
    <head>
      <title>{{ $t("pageTitle") }}</title>
    </head>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" class="my-16">
          <v-col cols="12" sm="8" md="4">
            <v-img
              v-if="!isFirstAccess"
              :src="
                logo_url
                  ? logo_url
                  : require('./assets/' + $t('$assets.fullLogo'))
              "
              contain
            />
          </v-col>
          <v-col v-if="showLoginDialog" cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>
                  <span>
                    <v-img
                      :src="require('./assets/' + $t('$assets.logoSmallWhite'))"
                      contain
                      height="32"
                      width="32"
                      class="me-3"
                      :class="$vuetify.rtl ? 'float-right' : 'float-left'"
                    />
                    {{ $t("App.title") }}
                  </span>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <ValidationObserver ref="observer">
                  <v-form>
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('App.account')"
                      rules="required"
                    >
                      <v-text-field
                        name="account_id"
                        prepend-icon="fa-tag"
                        type="text"
                        id="account_id"
                        v-model="login.account_id"
                        :label="$t('App.account')"
                        :error-messages="login.accountErrors.concat(errors)"
                        :disabled="loading"
                        @keyup.enter="doLogin()"
                    /></ValidationProvider>
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('App.username')"
                      rules="required"
                    >
                      <v-text-field
                        name="login_user_id"
                        prepend-icon="fa-user"
                        type="text"
                        id="login_user_id"
                        v-model="login.login_user_id"
                        :label="$t('App.username')"
                        :error-messages="login.usernameErrors.concat(errors)"
                        :disabled="loading"
                        @keyup.enter="doLogin()"
                    /></ValidationProvider>
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('App.password')"
                      rules="required"
                    >
                      <v-text-field
                        name="password"
                        prepend-icon="fa-lock"
                        id="password"
                        v-model="login.password"
                        :label="$t('App.password')"
                        :error-messages="login.passwordErrors.concat(errors)"
                        :disabled="loading"
                        @keyup.enter="doLogin()"
                        :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                    /></ValidationProvider>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions class="px-4">
                <v-checkbox dense v-model="remember" class="mt-n10">
                  <template v-slot:label>
                    <span class="caption">{{ $t("App.Remember") }}</span>
                  </template>
                </v-checkbox>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.stop="doLogin()">{{
                  $t("App.loginBtn")
                }}</v-btn>
              </v-card-actions>
              <v-progress-linear rounded :indeterminate="loading" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-footer v-if="showLoginDialog" inset app absolute color="transparent">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4"></v-col>
          <v-col
            cols="12"
            sm="8"
            md="4"
            :align="$vuetify.rtl ? 'left' : 'right'"
          >
            <v-menu open-on-hover top offset-y class="text-center">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined v-bind="attrs" v-on="on">{{
                  $t("langTitle")
                }}</v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="lang in langs"
                  :key="lang.key"
                  @click="locale = lang.key"
                >
                  <v-list-item-title>{{ lang.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <span class="ms-3">
              <v-btn
                icon
                v-if="!$vuetify.theme.dark"
                @click.stop="toggleDark()"
              >
                <v-icon>fa-sun</v-icon>
              </v-btn>
              <v-btn icon v-else @click.stop="toggleDark()">
                <v-icon>fa-moon</v-icon>
              </v-btn>
            </span>
          </v-col>
        </v-row>
      </v-footer>
    </v-main>

    <Footer />
    <DialogShop
            v-model="selectShopDialog"
            :shopLists="shopLists"
            @confirm="selectShop($event);"

    />
  </v-app>
  <v-app v-else-if="accessToken" id="yywd-front">
    <head>
      <title>{{ $t("pageTitle") }}</title>
    </head>
    <v-navigation-drawer
      v-if="!printMode"
      class="hidden-print"
      v-model="primaryDrawer.model"
      :clipped="primaryDrawer.clipped"
      :mini-variant="primaryDrawer.mini"
      app
      overflow
      dark
      overlay-opacity="0"
      color="sidebar"
      :right="$vuetify.rtl"
    >
      <Nav
        :settingMode="settingMode"
        :login="login"
        :locale="locale"
        @backToHome="
          settingMode = false;
          $route.path != '/' ? $router.push('/') : null;
        "
      />
    </v-navigation-drawer>

    <v-app-bar
      v-if="!printMode"
      class="hidden-print"
      :clipped-left="primaryDrawer.clipped"
      :clipped-right="primaryDrawer.clipped"
      app
      dense
      flat
      color="topbar"
    >
      <v-app-bar-nav-icon
        @click.stop="primaryDrawer.model = !primaryDrawer.model"
        color="navIcon"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-img
          :class="primaryDrawer.model ? 'd-flex d-lg-none' : ''"
          style="width: 100px"
          :src="require('./assets/' + $t('$assets.fullLogo'))"
          contain
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="me-6 d-none subtitle-2 secondary--text">{{
        $t("welcomeMessage", [
          accountUser ? accountUser.shop_code : "",
          accountUser ? accountUser.shop_name : "",
          accountInfo ? accountInfo.account_name : "",
        ])
      }}</span>
      <v-menu open-on-hover offset-y class="text-center" v-if="userType != 2">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="d-none d-md-flex ms-2"
            color="grey darken-2"
          >
            {{
              $t("welcomeMessage", [
                accountUser ? accountUser.shop_code : "",
                accountUser ? accountUser.shop_name : "",
                accountInfo ? accountInfo.account_name : "",
              ])
            }}
            <v-icon x-small class="ps-1">fa-caret-down</v-icon>
          </v-btn>
        </template>
        <v-list v-if="remenberedAccounts && remenberedAccounts.length > 0">
          <v-list-item
            v-for="(remenbered_account, idx) in remenberedAccounts"
            :key="idx"
            @click.stop="changeRemenberedAccount(remenbered_account)"
          >
            <v-list-item-title class="subtitle-2 secondary--text"
              >{{ remenbered_account.account_id }} / 【{{
                remenbered_account.shop_user.shop_code
              }}】{{
                remenbered_account.shop_user.shop_name
              }}</v-list-item-title
            >
            <v-list-item-action
              v-if="accessToken != remenbered_account.access_token"
              @click.stop="delRemenberedAccount(remenbered_account)"
            >
              <v-icon color="danger">fa-times</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu open-on-hover offset-y class="text-center" v-if="userType == 2">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  class="d-none d-md-flex ms-2"
                  color="grey darken-2"
          >
            {{
            $t("adminWelcomeMessage", [
            accountUser ? accountUser.name : "",
            logined_shop ? logined_shop.shop_name : "", "",
            ])
            }}
            <v-icon x-small class="ps-1">fa-caret-down</v-icon>
          </v-btn>
        </template>
        <v-list v-if="account_shops && account_shops.length > 0">
          <v-list-item
                  v-for="(shop, idx) in account_shops"
                  :key="idx"
                  @click.stop="changeAccountShop(shop)"
          >
            <v-list-item-title class="subtitle-2 secondary--text"
            >【{{
              shop.shop_code
              }}】{{
              shop.shop_name
              }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- <v-tooltip bottom v-if="!settingMode">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            color="navIcon"
            @click.stop="settingMode = true"
          >
            <v-icon small>fa-cogs</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("App.settings") }}</span>
      </v-tooltip>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            color="navIcon"
            @click.stop="settingMode = false"
          >
            <v-icon small>fa-home</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("App.home") }}</span>
      </v-tooltip> -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="me-2"
            @click.stop="doLogout()"
            color="navIcon"
          >
            <v-icon small>fa-sign-out-alt</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("App.logout") }}</span>
      </v-tooltip>
      <v-divider vertical />
      <v-menu open-on-hover offset-y class="text-center">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="d-flex d-sm-none ms-1"
            color="grey darken-2"
          >
            <v-icon>fa-language</v-icon>
          </v-btn>
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="d-none d-sm-flex ms-2"
            color="grey darken-2"
          >
            <v-icon x-small class="pe-2 pt-1">fa-language</v-icon
            >{{ $t("langName") }}
            <v-icon x-small class="ps-1">fa-caret-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="lang in langs"
            :key="lang.key"
            @click="locale = lang.key"
          >
            <v-list-item-title>{{ lang.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn icon v-if="!$vuetify.theme.dark" @click.stop="toggleDark()">
        <v-icon small>fa-sun</v-icon>
      </v-btn>
      <v-btn icon v-else @click.stop="toggleDark()">
        <v-icon small>fa-moon</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main id="app-main">
      <v-progress-linear
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        absolute
        top
        color="primary"
      />
      <v-row
        no-gutters
        dense
        v-if="printMode"
        class="py-4 px-8 hidden-print"
        style="
          position: absolute;
          top: 0px;
          left: 0px;
          right: 0px;
          background-color: rgba(255, 255, 255, 0.6) !important;
          z-index: 2 !important;
        "
      >
        <v-col cols="2">
          <v-select
            v-model="printPage"
            :items="$t('$print.pageNames')"
            dense
            solo
            hide-details
          />
        </v-col>
        <v-spacer />
        <v-btn dark color="grey" class="me-2 px-6" @click.stop="$router.go(-1)">
          <v-icon x-small class="pe-1">fa-reply</v-icon>
          {{ $t("CRUD.back") }}
        </v-btn>
        <v-btn dark color="print" class="px-6" v-print>
          <v-icon x-small class="pe-1">fa-print</v-icon>
          {{ $t("Print.print") }}
        </v-btn>
      </v-row>
      <v-sheet
        id="main-content"
        :color="printMode ? '' : 'topbar'"
        :class="
          printMode
            ? 'app-overflow-y-scroll app-fill-height'
            : 'app-overflow-y-scroll app-fill-content-height'
        "
        @scroll="scrollEvent()"
      >
        <router-view
          :style="
            printMode
              ? 'margin-left:auto;margin-right:auto;width:' +
                printPageOptions[printPageSize].width +
                'px;'
              : ''
          "
          :class="printMode ? 'print-layout-container' : ''"
          @change-district="changeDistrict"
          @to-parent-district="toParentDistrict"
        ></router-view>
        <v-data-table v-if="printMode" hidden />
      </v-sheet>
      <v-fab-transition>
        <v-btn
          v-if="toTopActive"
          color="accent"
          class="hidden-print"
          fab
          fixed
          bottom
          :left="$vuetify.rtl"
          :right="!$vuetify.rtl"
          @click.stop="toTop()"
        >
          <v-icon>fa-angle-up</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-main>

    <Footer v-if="!printMode" />

    <v-overlay
      :value="$store.state.fullscreenLoading"
      style="z-index: 999999 !important"
    >
      <v-progress-circular
        size="50"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
<!--    <v-overlay-->
<!--      opacity="0.67"-->
<!--      v-if="$store.state.fullscreenImages"-->
<!--      style="z-index: 999999 !important"-->
<!--    >-->
<!--      <v-carousel-->
<!--        height="100%"-->
<!--        hide-delimiters-->
<!--        :show-arrows="-->
<!--          $store.state.fullscreenImages &&-->
<!--          $store.state.fullscreenImages.length > 1-->
<!--        "-->
<!--      >-->
<!--        <v-carousel-item-->
<!--          v-for="(item, i) in $store.state.fullscreenImages"-->
<!--          :key="i"-->
<!--          class="fullscreen-images"-->
<!--          @click="$showFullscreenImages(null)"-->
<!--        >-->
<!--          <v-img :src="item" contain height="100%" />-->
<!--        </v-carousel-item>-->
<!--      </v-carousel>-->
<!--    </v-overlay>-->
  </v-app>
</template>

<script>
import Nav from "./Nav";
import Footer from "./Footer";
import i18n from "./i18n";
import { mapState } from "vuex";
import Auth from "@/api/authorizations";
import Shops from "@/api/shops";
import Settings from "@/api/settings";
import DialogShop from "@/components/plugins/DialogShop";
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'
Vue.use(VueViewer)

import { localize, ValidationObserver, ValidationProvider } from "vee-validate";
if (localStorage.getItem("locale"))
  i18n.locale = localStorage.getItem("locale");

export default {
  name: "App",

  components: {
    Nav,
    Footer,
    DialogShop,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    from() {
      return this.$route
        ? this.$route.params
          ? this.$route.params.from
          : ""
        : "";
    },
    districts_filter() {
      return (item, districts_search, textKey) =>
        item[textKey].indexOf(districts_search) > -1;
    },
    remenberedAccounts() {
      return this.remenbered_accounts.filter(
        (a) => this.accessToken != a.access_token
      );
    },
    isFirstAccess() {
      if (localStorage.getItem("login.account_id") || localStorage.getItem("login.login_user_id")) {
        return false;
      }
      return true
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "loading",
      "showSearchPanel",
      "showSparklinePanel",
      "fixHeaderHeightInPx",
      "mainContentScrolled",
      "printPageSize",
      "printMode",
      "accessToken",
      "accountInfo",
      "accountUser",
      "permission_districts",
      "serverDistricts",
      "districtID",
      "accountSettings",
      "userType",
      "adminLoginData",
      "fullscreenImages",
    ]),
  },

  data: () => ({
    logo_url: null,
    showLoginDialog: false,
    selectShopDialog: false,
    shopLists: [],
    toTopActive: false,
    primaryDrawer: {
      model: true,
      type: "Default (no property)",
      clipped: false,
      mini: false,
    },
    showPassword: false,
    login: {
      account_id: "",
      login_user_id: "",
      password: "",
      accountErrors: [],
      usernameErrors: [],
      passwordErrors: [],
    },
    remenbered_accounts: [],
    langs: [
      { title: "简体中文", key: "zhHans" },
      { title: "English", key: "en" },
      { title: "Español", key: "es" },
    ],
    locale: "",
    remember: true,
    tree: [],
    printPage: i18n.t("$print.defaultPageOption"),
    printPageOptions: i18n.t("$print.pageOptions"),
    settingMode: false,
    account_shops: [],
    logined_shop:{}
  }),

  watch: {
    $route(to) {
      // 打印模式切换↓
      this.$store.commit("printMode", to.path.startsWith("/print/"));
      if (this.printMode) {
        var printPageSize = localStorage.getItem("printPageSize");
        printPageSize = printPageSize
          ? printPageSize
          : i18n.t("$print.defaultPageOption");
        this.$store.commit("printPageSize", printPageSize);
        localStorage.setItem("printPageSize", printPageSize);
        this.printPage = printPageSize;
      }
      this.logo_url = localStorage.getItem("logo_url");
    },
    mainContentScrolled: {
      handler() {
        this.toTopActive = this.mainContentScrolled > 100;
        // ↓fix-header效果用
        // if (this.toTopActive) this.$store.commit("closeSearchPanel");
        // else if (
        //   this.fixHeaderHeightInPx > 100 &&
        //   this.mainContentScrolled == 0
        // )
        //   this.$store.commit("openSearchPanel");
      },
    },
    showSearchPanel: {
      handler() {
        this.$setIntervalMainResizer();
      },
    },
    showSparklinePanel: {
      handler() {
        this.$setIntervalMainResizer();
      },
    },
    printPage: {
      handler() {
        this.$store.commit("printPageSize", this.printPage);
        localStorage.setItem("printPageSize", this.printPage);
      },
    },
    printMode: {
      immediate: true,
      handler() {
        if (this.printMode) this.$vuetify.theme.dark = false;
        else {
          if (
            localStorage.getItem("dark") &&
            localStorage.getItem("dark") != "false"
          )
            this.$vuetify.theme.dark = true;
          else this.$vuetify.theme.dark = false;
        }
      },
    },
    locale: {
      handler() {
        this.$i18n.locale = this.locale;
        localize({ en: i18n.t("$validate") }); // validate语言本地化
        localStorage.setItem("locale", this.locale);
      },
    },
    from: {
      handler() {
        if (this.from) {
          let loginData = {
            from: this.from,
            access_token: this.$route.params.access_token,
            account_id: this.$route.query.account_id,
            account_user_id: this.$route.query.account_user_id,
            shop_id: this.$route.query.shop_id,
          }
          this.$store.commit("ADMINLOGIN", loginData);
          Auth.login(loginData).then(
            function () {
              this.$router.replace(
                this.$route.params.redirect ? this.$route.params.redirect : "/"
              );
            }.bind(this)
          ); // 尝试从跳转参数from和accessToken换取登录状态
        }
      },
    },
    accessToken: {
      handler() {
        if (this.accessToken) {
          if (this.userType == 0) {
            Shops.accountFetch();
          }else if (this.userType == 1) {
            Shops.fetch();
            Settings.getShopSettings()
          } else if (this.userType == 2) {
            Shops.getAllShops({psi_enable:1}).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.account_shops = [];
                  response.data.shops.map((shop) => {
                    if (shop.id != JSON.parse(localStorage.getItem("adminLoginData")).shop_id) {
                      this.account_shops.push({
                        id: shop.id,
                        shop_code: shop.shop_code,
                        shop_name: shop.shop_name
                      })
                    }else {
                      this.logined_shop.shop_code = shop.shop_code
                      this.logined_shop.shop_name = shop.shop_name
                    }
                  })
                }
              }.bind(this)
            );
            Shops.getAccountUser(JSON.parse(localStorage.getItem("adminLoginData")).account_user_id)
          }
          if (this.userType != 2) {
            //获取品牌端设置项
            Shops.getAccountSettings()
          }
        } else if (this.$route.path != "/") {
          this.$router.push("/");
        }
      },
    },
    primaryDrawer: {
      immediate: true,
      deep: true,
      handler() {
        this.$store.commit("primaryDrawer", this.primaryDrawer.model);
        this.$stickTableResizer();
      },
    },
    accountUser: {
      handler() {
        if (this.accountUser) {
          if (
            !this.remenbered_accounts.find(
              (a) => a.access_token == this.accessToken
            )
          ) {
            var prev_one = this.remenbered_accounts.find(
              (a) =>
                JSON.stringify(a.shop_user) == JSON.stringify(this.accountUser)
            );
            if (prev_one) {
              prev_one.access_token = this.accessToken;
            } else {
              // 记入备选账号本地存储
              this.remenbered_accounts.push({
                access_token: this.accessToken,
                account_id: this.login.account_id,
                login_user_id: this.login.login_user_id,
                shop_user: this.accountUser,
              });
            }
            localStorage.setItem(
              "remenbered_accounts",
              JSON.stringify(this.remenbered_accounts)
            );
          }
        }
      },
    },
    fullscreenImages: {
      handler() {
        if (this.fullscreenImages) {
          this.$viewerApi({
            images: this.fullscreenImages,
          })
        }
      }
    },
  },

  mounted() {
    this.$store.commit("districtID", 0);
  },

  created() {
    this.locale = this.$i18n.locale;
    if (localStorage.getItem("dark") && localStorage.getItem("dark") != "false")
      this.$vuetify.theme.dark = true;
    this.login.account_id = localStorage.getItem("login.account_id");
    this.login.login_user_id = localStorage.getItem("login.login_user_id");
    if (localStorage.getItem("adminLoginData")) {
      Auth.login(JSON.parse(localStorage.getItem("adminLoginData")))
    }else {
      if (localStorage.getItem("accessToken")) {
        Auth.check().then(
                function () {
                  this.showLoginDialog = !this.accessToken;
                }.bind(this)
        ); // 检查本地accessToken的登录状态
      } else {
        this.showLoginDialog = true;
      }
    }
    // 读取本地备选账号数组
    var remenbered_accounts = localStorage.getItem("remenbered_accounts");
    if (remenbered_accounts) {
      this.remenbered_accounts = JSON.parse(remenbered_accounts);
    }
  },

  methods: {
    scrollEvent() {
      this.$store.commit(
        "mainContentScrolled",
        document.getElementById("main-content").scrollTop
      );
    },
    toTop() {
      this.$scrollTop(); //返回顶部
    },
    toggleDark() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark", this.$vuetify.theme.dark);
    },
    selectShop(selectedShop) {
      let loginData =  {
        account_id: this.login.account_id,
        login_user_id: this.login.login_user_id,
        password: this.login.password,
        shop_id: selectedShop.shop_id
      }
      this.autoLogin(loginData)
    },
    doLogin() {
      if (this.loading) return;
      if (
        !this.login.account_id ||
        !this.login.login_user_id ||
        !this.login.password
      )
        return;
      this.login.accountErrors = [];
      this.login.usernameErrors = [];
      this.login.passwordErrors = [];
      // 获取门店多用户设置项
      Settings.getAccountSettings({
        account_id: this.login.account_id,
        keys: ['shop_multiple_account']
      }).then((settingResponse) => {
        if (settingResponse.data && settingResponse.data.status.isOK()) {
          let loginData = {
            account_id: this.login.account_id,
            login_user_id: this.login.login_user_id,
            password: this.login.password
          }
          if (settingResponse.data.account_settings.shop_multiple_account == 1) {
            Auth.accountPasswordForShops(loginData).then((response) => {
              if (response.data.status.isOK()) {
                // 门店多用户 获取门店列表
                this.shopLists = response.data.shops
                if (this.shopLists.length == 1) {
                  // 单个门店直接登陆
                  loginData.shop_id = this.shopLists[0].shop_id
                  this.autoLogin(loginData)
                } else {
                  // 多门店 打开选择门店弹框
                  this.selectShopDialog = true
                }
              } else {
                //其他错误（包括ERR001登录失败）
                this.login.passwordErrors = [response.data.error.msg];
              }
            });
          } else {
            // 未开启门店多账户 直接登录
            this.autoLogin(loginData)
          }
        }
      })
    },
    autoLogin(loginData) {
      Auth.login(loginData).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.showLoginDialog = false;
                  if (this.remember) {
                    localStorage.setItem("login.account_id", this.login.account_id);
                    localStorage.setItem(
                            "login.login_user_id",
                            this.login.login_user_id
                    );
                  } else {
                    localStorage.removeItem("login.account_id");
                    localStorage.removeItem("login.login_user_id");
                  }
                } else if (response.data.error.code == "ERR020") {
                  //品牌校验失败
                  this.login.accountErrors = [response.data.error.msg];
                } else if (response.data.error.code == "ERR002") {
                  //账号密码错误
                  this.login.usernameErrors = [response.data.error.msg];
                  this.login.passwordErrors = [response.data.error.msg];
                } else {
                  //其他错误（包括ERR001登录失败）
                  this.login.passwordErrors = [response.data.error.msg];
                }
              }.bind(this)
      );
    },
    doLogout() {
      var prev_one = this.remenbered_accounts.find(
        (a) => a.access_token == this.accessToken
      );
      Auth.logout();
      if (prev_one) {
        prev_one.access_token = "";
        localStorage.setItem(
          "remenbered_accounts",
          JSON.stringify(this.remenbered_accounts)
        );
      }
      this.showLoginDialog = true;
    },
    changeDistrict(district) {
      if (district) this.$store.commit("districtID", district.id);
    },
    toParentDistrict() {
      if (this.districtID) {
        let district = this.findDistrictNode(this.districts, this.districtID);
        if (district)
          this.$store.commit(
            "districtID",
            district.parent_id ? district.parent_id : 0
          );
      }
    },
    changeRemenberedAccount(remenbered_account) {
      if (remenbered_account.access_token == this.accessToken) return; //当前登录用户不能切换
      localStorage.setItem("login.account_id", remenbered_account.account_id);
      localStorage.setItem(
        "login.login_user_id",
        remenbered_account.login_user_id
      );
      this.$store.commit("LOGIN", remenbered_account.access_token);
      this.$router.go(0);
    },
    delRemenberedAccount(remenbered_account) {
      if (remenbered_account.access_token == this.accessToken) return; //当前登录用户不能删除
      this.remenbered_accounts.splice(
        this.remenbered_accounts.findIndex((a) => a == remenbered_account),
        1
      );
      localStorage.setItem(
        "remenbered_accounts",
        JSON.stringify(this.remenbered_accounts)
      );
    },
    changeAccountShop(shop) {
      let postData = JSON.parse(localStorage.getItem("adminLoginData"))
      postData.shop_id = shop.id
      Auth.login(postData)
      this.$store.commit("ADMINLOGIN", postData);
      this.$router.go(0);
    }
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
    this.$store.dispatch("fullscreenLoadingStop");
  },
};
</script>